export default __webpack_public_path__ + "static/media/task_red_icon.0ecb9536.svg";